import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    name: 'Loader',
})
export default class Loader extends Vue {
    @Prop(Boolean)
    loading!: boolean;

    color: string = '#5dc596';

    height: string = '35px';

    width: string = '4px';

    margin: string = '2px';

    radius: string = '2px';

    delay: number = 0;


    spinnerStyle: any = {
        backgroundColor: this.color,
        height: this.height,
        width: this.width,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-scaleStretchDelay',
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
    };
    spinnerDelay1: any = {
        animationDelay: '0.1s'
    };
    spinnerDelay2: any = {
        animationDelay: '0.2s'
    };
    spinnerDelay3: any = {
        animationDelay: '0.3s'
    };
    spinnerDelay4: any = {
        animationDelay: '0.4s'
    };
    spinnerDelay5: any = {
        animationDelay: '0.5s'
    }
}